import React, { useState } from 'react'
import './EditSelectedBoxesModal.scoped.sass'
import modalService from '@/services/modal.service'
import labelsService from '@/app-domains/labels/labels.service'
import store from '@/core/store'

import { ReactComponent as CloseIcon } from '@/assets/icons/close-icon.svg'
import { Button } from '@/components/Button/Button'
import { Radio } from '@/components/Radio/Radio'
import boxesService from '@/app-domains/boxes/boxes.service'

const EditSelectedBoxesModal = (props, box) => {
  const [selectedLabels, setSelectedLabels] = useState(labelsService.findLabelsForBox(box))
  // eslint-disable-next-line
  const [showLabelCreationInput, setShowLabelCreationInput] = useState(false)
  const [selectedBoxes] = useState(boxesService.getSelectedBoxesFromStore())

  const onLabelSelected = (newlySelectedLabel) => {
    if (selectedLabels.find((label) => label.composedid === newlySelectedLabel.composedid)) {
      const newSelectedLabels = selectedLabels.filter((label) => label.composedid !== newlySelectedLabel.composedid)
      setSelectedLabels(newSelectedLabels)
    } else {
      setSelectedLabels([newlySelectedLabel, ...selectedLabels])
    }
  }

  function getSelectedBoxes () {
    return (
      selectedBoxes.map((selectedBox) => {
        return (
          <div key={selectedBox.boxname || selectedBox.boxalias} className='selected-box'>
            {selectedBox.boxalias || selectedBox.boxname}
          </div>
        )
      })
    )
  }

  function getCloseFunctionality () {
    modalService.close()
    selectedBoxes.forEach((selectedBox) => {
      store.commit(`${selectedBox.id}:UNMARKED`, selectedBox)
    })
    
    boxesService.saveSelectedBoxes([])
  }

  return (
    <div className='main-container'>
      <div className='top-header'>
        <div className='header-title'>
          Edit selected boxes
        </div>
        <div className='close-button' onClick={() => { getCloseFunctionality() }}>
          <CloseIcon />
        </div>
      </div>
      <div className='main-content'>
        <div className='selected-boxes-container'>
          {getSelectedBoxes()}
        </div>
        <div className='choose-labels-container'>
          { !showLabelCreationInput && <div className="radios">
            {Object.values(labelsService.getLabelsFromStore()).map((label, index) => {
              return <Radio
              key={index}
              label={label?.name}
              name={label?.name}
              onChecked={() => onLabelSelected(label)}
              checked={selectedLabels.filter((sl) => sl.composedid === label.composedid).length > 0} />
            })}
          </div>
        }
        </div>
        <div className='buttons-div'>
          <div className='cancel-button'>
            <Button content='Cancel' type='secondary' click={() => { getCloseFunctionality() }}/>
          </div>
          <div className='create-contact-button'>
            <Button content='Save' click={() => {
              selectedBoxes.forEach((selectedBox) => {
                boxesService.attachLabelsToBox(selectedBox, selectedLabels)
                store.commit(`${selectedBox.id}:UNMARKED`, selectedBox)
              })
              boxesService.saveSelectedBoxes([])
              setTimeout(() => { store.commit('THREADS:UPDATED') }, 1000)
              modalService.close()
            }} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default EditSelectedBoxesModal
